import {
  Box,
  Button,
  IconButton,
  Stack,
  Tab,
  Tabs,
  useTheme,
} from "@mui/material";
import React, { Fragment, SetStateAction, useEffect, useState } from "react";
import GeralMenu from "../geralMenu";
import { v4 as uuidv4 } from "uuid";
import GraphicConfigMenu from "../graphicConfigMenu";
import { Add, Close } from "@mui/icons-material";
import NewAlertModal from "../newAlertModal";

interface EditorMenuProps {
  card: DashCardsGraphics | undefined;
  updateCard: (newCard: DashCardsGraphics) => void;
  setResultQuery: React.Dispatch<SetStateAction<any[]>>;
  setErrorQuery: React.Dispatch<SetStateAction<string>>;
  setSelectedGraphicId: React.Dispatch<SetStateAction<string>>;
  setLoading: React.Dispatch<SetStateAction<boolean>>;
  pageId: string;
}

const newGraph = {
  id: uuidv4(),
  type: "pie",
  config: {
    keys: [],
    keyLine: "",
    indexBy: "",
    units: "numerico",
    colorsByKey: {},
    colors: {},
  },
  metricsType: [],
};

const EditorMenu: React.FC<EditorMenuProps> = ({
  card,
  updateCard,
  setResultQuery,
  setSelectedGraphicId,
  setErrorQuery,
  setLoading,
  pageId,
}) => {
  const theme = useTheme();
  const [tabValue, setTabValue] = useState<number>(0);
  const [graphics, setGraphics] = useState<(typeof newGraph)[]>([]);
  const [openAlertModal, setOpenAlertModal] = useState<boolean>(false);
  const [graphicId, setGraphicId] = useState<string>("");

  useEffect(() => {
    if (card?.graphics && card.graphics.length > 0) setGraphics(card.graphics);
  }, [card?.graphics]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  const handleAddGraphic = () => {
    const newGraphics = graphics
      ? [...graphics, { ...newGraph, id: uuidv4(), data: [] }]
      : [{ ...newGraph, id: uuidv4(), data: [] }];
    setGraphics(newGraphics);
    if (card && card !== undefined) {
      updateCard({ ...card, graphics: newGraphics });
    }
    setTabValue(newGraphics.length - 1);
  };
  const handleRemoveGraphic = (id: string) => {
    if (!graphics) return;
    const newGraphics = graphics.filter((graph) => graph.id !== id);
    setGraphics(newGraphics);
    if (card) {
      updateCard({ ...card, graphics: newGraphics });
    }
    setOpenAlertModal(false);
    setTabValue(0);
  };
  const handleUpdateGraphic = (newGraphic: DashGraphicsCards) => {
    const newgraphics = graphics.map((graphic) => {
      return graphic.id === newGraphic?.id
        ? { ...graphic, ...newGraphic }
        : graphic;
    });
    const newCard = {
      ...card,
      graphics: newgraphics,
      size: card?.size ?? 1,
    };
    updateCard(newCard as DashCardsGraphics);
  };
  return (
    <>
      <Stack
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.background.paper,
          padding: 1,
          overflowY: "auto",
        }}
      >
        <Tabs
          sx={{ paddingLeft: 1 }}
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab disableRipple disableFocusRipple label="Painel" value={0} />

          {graphics.map((graphic, index) => (
            <Tab
              key={graphic.id}
              disableRipple
              disableFocusRipple
              onClick={() => setSelectedGraphicId(graphic.id)}
              label={
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  Gráfico {index + 1}
                  {graphics.length > 1 && (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenAlertModal(true);
                        setGraphicId(graphic.id);
                      }}
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  )}
                </Box>
              }
              value={index + 1}
            />
          ))}
          <Button
            sx={{ color: theme.palette.primary.main }}
            onClick={handleAddGraphic}
            variant="text"
          >
            <Add />
          </Button>
        </Tabs>
        {tabValue === 0 && <GeralMenu card={card} updateCard={updateCard} />}
        {graphics.map(
          (graphic, index) =>
            tabValue === index + 1 && (
              <Fragment key={index}>
                <GraphicConfigMenu
                  card={card}
                  updateCard={updateCard}
                  setResultQuery={setResultQuery}
                  setErrorQuery={setErrorQuery}
                  setLoading={setLoading}
                  pageId={pageId}
                  graphic={graphic}
                  handleUpdateGraphic={handleUpdateGraphic}
                />
              </Fragment>
            ),
        )}
      </Stack>
      <NewAlertModal
        openModal={openAlertModal}
        setOpenModal={setOpenAlertModal}
        buttonText="Salvar"
        buttonCancelText="Voltar"
        confirmar={false}
        handleButton={() => {
          handleRemoveGraphic(graphicId);
        }}
        handleCancel={() => {
          setOpenAlertModal(false);
        }}
        severity="warning"
        singleButton={false}
        textContent="Tem certeza que deseja excluir o gráfico?"
      />
    </>
  );
};
export default EditorMenu;
